import { questionReviewPath, reviewQuestionPosition } from "../../utils/review-question-route";
/* global globalThis */
import { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExamHeader from "../../components/exam-header/exam-header";
import ExamFooter from "../../components/exam-footer/exam-footer";
import ExamQuestionContainer from "../../components/exam-question-container/exam-question-container";
import ExamQuestionNumberList from "../../components/exam-question-number-list/exam-question-number-list";
import ExamReviewDrawer from "../../components/exam-review-drawer/exam-review-drawer";
import { Box, Backdrop, CircularProgress, IconButton, Snackbar, Typography, Button } from "@material-ui/core";
import { useHistory, useParams, useLocation } from "react-router-dom";
import mixpanel from 'mixpanel-browser';
import { api } from "../../services/apiService";
import { applyClientConfig } from "../../constants/app-constant";
import { Launch } from "@material-ui/icons";
import {
  getQuiz,
  submitQuiz,
  resetSubmitQuiz,
  getQuestionMetadata,
  getOversightQuiz,
  getOversightQuizHistory,
  getOversightQuestionHistory,
  getOversightQuestionMetadata,
  getQuestionHistory,
  reviewQuestion,
  resetQuiz,
  setUserActivity,
  getImage,
  resetQuestionMetadata,
  endTutorFeedbackBlock,
  resetQuesFeedback,
  getDemoQuestionMetadata,
  getDemoQuestionIDs,
  resetDemoQuestionMetadata,
  resetDemoQuestionIDs,
  getQuizHistory,
  userDetailsFromToken
} from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { persistAttribution } from "../../utils/attribution";
import {
  hasUsableDemoQuestionMetadata,
  resolveQuestionMetadataError,
} from "./examMetadata";
import { trackMobileFirstQuizCompleted } from "../../services/mobileActivationAnalytics";
import { trackFirstQuestionReached } from "../../utils/activation-timing";
import QLinkLinkError from "../../components/qlink-link-error/qlink-link-error";
import { restoreQLinkShareToken } from "../../utils/qlink-share-token";
import { buildQlinkPracticeState, resolveQlinkExamLabel } from "../../utils/qlink-exam-seed";
import { subscribeToSessionCleared } from "../../utils/stale-session";
import {
  isRecordingReloadInProgress,
  onBeforeRecordingReload,
} from "../../utils/replay-consent";
import { stashExamReloadState, takeQuizResume } from "../../utils/exam-reload-state";

let examHistoryData = {};
let strikedHistoryData = {};
const reviewTimer = {};
const testingTime = {};
let interval;
let guideWindow = null;
let nextQlinkRequestScope = 0;

const selectQuestionMetadataState = (state, isAcquisitionRoute) => (
  !isAcquisitionRoute && (state?.questionMetadata?.qlinkReceipt || state?.questionMetadataErrMsg?.qlinkGuidance)
    ? {} : state
);

const selectQlinkGuidanceError = (isAcquisitionRoute, unavailable, error, isCurrentReceipt) => {
  if (!isAcquisitionRoute) return undefined;
  if (unavailable) return { qlinkGuidance: true, status: 404, reason: "missing-token" };
  if (error && typeof error === "object" && error.qlinkGuidance && isCurrentReceipt(error.receipt)) {
    return error;
  }
  return undefined;
};

//test comment

const normalizeQLinkPlatform = (value) => {
  const normalized = value?.trim().toLowerCase();
  if (normalized && /^[a-z0-9_-]{1,50}$/.test(normalized)) {
    return normalized;
  }

  return 'unknown';
};

const getQuestionIds = (questions = []) => (
  [...questions].map(item => item?.id || item?.questionId).filter(Boolean)
);

const normalizeQuestions = (questions = []) => (
  [...questions].map(q => ({
    ...q,
    questionId: q?.questionId || q?.id
  }))
);

// Auth rotation cleanup: everything the PREVIOUS auth revealed must leave the
// render path (stems stay; guidance/reveal fields go).
const stripGuidanceFields = (question = {}) => {
  const { briefExplanation, additionalExplanation, explanation, ...rest } = question;
  if (rest.option && typeof rest.option === "object") {
    const { correctAnswer, ...option } = rest.option;
    return { ...rest, option };
  }
  return rest;
};

const mergeQuestionsWithMetadata = (questions = [], metadata = []) => {
  if (!questions.length) {
    return normalizeQuestions(metadata);
  }

  const metadataById = new Map(
    normalizeQuestions(metadata).map(item => [item.questionId, item])
  );

  return normalizeQuestions(questions).map(question => {
    const metadataItem = metadataById.get(question.questionId);
    return metadataItem ? { ...question, ...metadataItem } : question;
  });
};

const getAcquisitionLayout = (isAcquisitionRoute, questionCount, signedOut = false) => {
  const hideQuestionRail = isAcquisitionRoute && questionCount === 1;
  // A signed-out visitor of a one-question shared link: on phones the app
  // header and the (empty for them) footer band give way to the case, so the
  // stem and every option fit on the first screen (exam-question-container.scss).
  const compactPhone = hideQuestionRail && signedOut;
  return {
    hideQuestionRail,
    className: `${hideQuestionRail ? ' single-question-acquisition' : ''}${compactPhone ? ' qlink-compact-phone' : ''}`,
  };
};

// No session on this device: neither the page's resolved login nor a stored
// token or role (either holds the signed-in layout until the page resolves it
// or the stale-session guard clears it, so a returning student never sees the
// compact layout flash).
const hasStoredSession = () => {
  try {
    return !!(window.localStorage.getItem("token") || window.localStorage.getItem("role"));
  } catch (e) {
    return false;
  }
};

const resolveReviewPosition = (questionId, loadedQuizId, examId, questions, legacyPosition) => {
  if (!questionId) return legacyPosition;
  if (loadedQuizId !== examId) return 0;
  return reviewQuestionPosition(questions, questionId);
};

const getSelectedReviewStatus = ({ requestedReviewQuestionId, currentQuestionNum,
  examDetailsLoading, examDetails, questionsQuizId, examId, oversight, studentUserId, history }) => {
  if (requestedReviewQuestionId && currentQuestionNum === 0) {
    if (examDetailsLoading !== false || (examDetails && questionsQuizId !== examId)) {
      return <Box role="status">Loading the selected question…</Box>;
    }
    return <Box role="alert">
      <Typography>{examDetails ? "This question is no longer available for review."
        : "We couldn’t load this quiz. Return to results and try again."}</Typography>
      <Button onClick={() => history.push(oversight
        ? `/mentorships/students/${studentUserId}/result/${examId}` : `/result/${examId}`)}>
        Back to results
      </Button>
    </Box>;
  }

  return null;
};

const getEmptyQuestionStatus = ({ examDetailsLoading, questionsData,
  demoQuestionMetadata, qlinkQsIds, questionMetadata, classes }) => {
  if (examDetailsLoading !== undefined && examDetailsLoading === false && !questionsData.length && !demoQuestionMetadata?.questionMetadata?.errMsg && !qlinkQsIds?.errMsg) {
    return <div>Encountered error while fetching questions</div>
  }

  if (examDetailsLoading !== undefined && examDetailsLoading === false && !questionsData.length && !qlinkQsIds?.errMsg && (!questionMetadata?.errMsg || !demoQuestionMetadata?.questionMetadata?.errMsg)) {
    return <Box className={classes.noQuestionsAvailableMessage}>No questions found. Please retry.</Box>
  }

  if (examDetailsLoading !== undefined && examDetailsLoading === false &&!questionsData.length && qlinkQsIds?.errMsg) {
    return <QLinkLinkError status={qlinkQsIds?.status} expired={qlinkQsIds?.expired === true} />
  }

  return null;
};

export default function ExamPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [showEndBlock, setShowEndBlock] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [legacyQuestionNum, setLegacyQuestionNum] = useState(1);
  const [questionsData, setQuestionsData] = useState([]);
  const [questionsQuizId, setQuestionsQuizId] = useState(null);
  const [questionMetadataArr, setQuestionMetadataArr] = useState([]);
  const [quizHistoryData, setQuizHistoryData] = useState([]);
  const [zoomClass, setZoomClass] = useState("smallFont");
  const [questionImage, setQuestionImage] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [quesMetadata, setQuesMetadata] = useState({});
  const [isTutorRole, setIsTutorRole] = useState(false);
  const [open, setOpen] = useState(false);
  const [errMsg, setErrMsg] = useState(false);
  const [isUserAcquisition, setIsUserAcquisition] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [qlinkPlatform, setQlinkPlatform] = useState(null);
  // QLink same-case guidance: a logged-in acquisition viewer whose local
  // share token is gone cannot assert the same-case entitlement — this flag
  // renders the actionable reopen-link state instead of an unbounded
  // fallback to generic bank metadata (QLINK-EXPLANATION-CONTRACT-SEPT16).
  const [qlinkGuidanceUnavailable, setQlinkGuidanceUnavailable] = useState(false);
  // Bumped when the stale-session guard clears a login the server rejected
  // (see the QLink signed-out switch below).
  const [sessionClearCount, setSessionClearCount] = useState(0);

  const location = useLocation();
  const currentRoute = location.pathname;
  // Route-derived, unlike the isUserAcquisition STATE which is false for the
  // whole first commit: the stale-guidance guard below must already hold on
  // the mount pass, or metadata left in the store by a previous quiz/case
  // renders once before the state catches up.
  const isAcquisitionRoute = currentRoute.includes("/question/view");

  const { examId, currentQuestion, review, tutor, guide, qId, studentUserId } = useParams();

  // Turning session recording off reloads the page (a running recorder cannot
  // be stopped). On a quiz that reload must not eject the student: it comes
  // back to this question with the answers, marks, strikes, time per question
  // and block timer kept (review of #866, UX 2). Decided once, on the first
  // render, before any child reads the answers.
  const resumeAfterRecordingReloadRef = useRef(undefined);
  if (resumeAfterRecordingReloadRef.current === undefined) {
    const kept = takeQuizResume();
    if (kept && kept.answers) {
      examHistoryData = kept.answers.examHistoryData || {};
      strikedHistoryData = kept.answers.strikedHistoryData || {};
      Object.assign(testingTime, kept.answers.testingTime || {});
    }
    resumeAfterRecordingReloadRef.current = kept;
  }
  const resumedAfterRecordingReload = resumeAfterRecordingReloadRef.current !== null;
  // Oversight quiz-open (contract qlearn-oversight-quiz-open-v1): the
  // :studentUserId param (mentorship proxy route, review-only) flips this
  // screen into READ-ONLY oversight. Data loads through the server-guarded
  // proxy reads; every viewer-keyed write (review-time tracking, feedback
  // blocks, activity counters, question feedback) is suppressed AT ITS
  // DEFINITION so no call site can fire it. The server is the gate.
  const oversight = Boolean(studentUserId) && Boolean(review);
  const requestedReviewQuestionId = review && examId
    ? new URLSearchParams(location.search).get("questionId") : null;
  const currentQuestionNum = resolveReviewPosition(
    requestedReviewQuestionId, questionsQuizId, examId, questionsData, legacyQuestionNum
  );
  const currentImageId = questionsData[currentQuestionNum - 1]?.imageList?.[0];
  // Never render the previous case's image while the selection effect catches up.
  const imageData = questionImage?.id === currentImageId ? questionImage?.data || "" : "";
  const oversightReviewPath = (n) =>
    questionReviewPath(examId, n, questionsData[n - 1]?.questionId, studentUserId);
  const oversightExitPath = `/mentorships/students/${studentUserId}`;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const authenticatedMetadataRequestRef = useRef("");
  // Round-2 provenance: every authenticated acquisition request carries a
  // receipt — a mount-unique request id plus the auth snapshot it was issued
  // under. apiService echoes it onto SUCCESS/ERROR, and NOTHING is adopted
  // for render unless its receipt matches the latest issued request AND the
  // auth that is live right now. Ids + token-presence alone are not identity.
  // Correlation only: private auth epoch and server authorization remain the gates.
  const qlinkRequestSaltRef = useRef(null);
  if (qlinkRequestSaltRef.current === null) {
    qlinkRequestSaltRef.current = ++nextQlinkRequestScope;
  }
  const qlinkRequestSeqRef = useRef(0);
  const activeQlinkReceiptRef = useRef(null);
  // Compare credentials exactly in a private ref; only an opaque counter
  // enters receipts/Redux. No lossy hash can alias two different logins.
  const qlinkAuthRef = useRef({ token: null, epoch: 0 });
  const currentQlinkAuthEpoch = () => {
    const token = globalThis.localStorage.getItem("token");
    if (qlinkAuthRef.current.token !== token) {
      qlinkAuthRef.current = { token, epoch: qlinkAuthRef.current.epoch + 1 };
    }
    return qlinkAuthRef.current.epoch;
  };
  // The receipt of the auth-route content CURRENTLY held in local state —
  // consulted at RENDER time, because effects clear stale-by-auth content
  // only after a first re-render has already happened.
  const adoptedQlinkReceiptRef = useRef(null);

  const isCurrentQlinkReceipt = (receipt) => {
    const latest = activeQlinkReceiptRef.current;
    if (!receipt || !latest) {
      return false;
    }
    const liveToken = globalThis.localStorage.getItem("token");
    return receipt.requestId === latest.requestId
      && receipt.linkId === latest.linkId
      && receipt.linkId === qId
      && receipt.auth === latest.auth
      && !!liveToken
      && currentQlinkAuthEpoch() === receipt.auth;
  };
  const questionParam = {
    question_list: []
  };

  const examDetails = useSelector((state) => {
    return state.quizDetails?.quizDetails;
  });

  const examDetailsLoading = useSelector((state) => {
    return state.quizDetails?.loading;
  });

  const questionHistory = useSelector((state) => {
    return state.questionHistory?.questionHistory;
  });

  const submitQuizRes = useSelector((state) => {
    return state.submitQuiz?.submitQuiz;
  });

  const rawQuestionMetadataState = useSelector((state) => {
    return state.questionMetadata;
  });
  // A delayed shared-case result must never become ordinary quiz metadata:
  // that surface must refetch through its own quizId/strip boundary.
  const questionMetadataState = selectQuestionMetadataState(rawQuestionMetadataState, isAcquisitionRoute);

  const questionMetadata = questionMetadataState?.questionMetadata;
  const questionMetadataLoading = questionMetadataState?.loading === true;
  const questionMetadataLoaded = Array.isArray(questionMetadata) || !!questionMetadataState?.questionMetadataErrMsg;

  const reviewQuestionData = useSelector((state) => {
    return state.reviewQuestion;
  });

  const imageDataRes = useSelector((state) => {
    return state.getImage;
  });

  const setQuesTutorFeedbackRes = useSelector((state) => {
    return state.setQuesTutorFeedback;
  });

  const demoQuestionMetadata = useSelector((state) => {
    return state.getDemoQuestionMetadata;
  });

  const qlinkQsIds = useSelector((state) => {
    return state.getDemoQuestionIds;
  });

  const userDetailsFromTokenRes = useSelector((state) => {
    return state.userDetailsFromToken?.userDetails;
  });

  const handleClose = () => {
    setOpen(false);
    setErrMsg(false);
  };

  const startTimer = () => {
    const questionData = questionsData[currentQuestionNum - 1];

    if (review) {
      const questionHistoryData = questionHistory.filter(
        (item) => item.questionId === questionData?.questionId
      );

      interval = setInterval(() => {
        reviewTimer[questionData?.questionId] =
          reviewTimer[questionData?.questionId] + 1 ||
          questionHistoryData[0]?.reviewTimeSpent ||
          1;
      }, 1000);
    } else {
      interval = setInterval(() => {
        testingTime[questionData?.questionId] = testingTime[questionData?.questionId] + 1 || 1;
      }, 1000);
    }
  };

  const updateReviewApi = () => {
    if (oversight) {
      // Read-only oversight: review-time tracking belongs to the OWNER's
      // review sessions, never an overseer's (contract I5).
      return;
    }
    const questionData = questionsData[currentQuestionNum - 1];
    const questionHistoryData = questionHistory.filter(
      (item) => item.questionId === questionData?.questionId
    );

    if (!questionHistoryData[0]?.id) return;
    const param = {
      questionId: questionHistoryData[0].id,
      reviewTime: {
        reviewTimeSpent: reviewTimer[questionData?.questionId],
      },
    };

    dispatch(reviewQuestion(param));
  };

  const endFeedBackBlock = () => {
    if (oversight) {
      return; // no block was created in oversight (contract I5)
    }
    const blockId = window.localStorage.getItem('feedbackBlockId');

    if (blockId) {
      dispatch(endTutorFeedbackBlock(blockId));
      window.localStorage.removeItem('feedbackBlockId');
    }
  }

  const preventNav = (event) => {
    updateReviewApi();
    // The reload that turns recording off is the app's own: no "Leave site?"
    // prompt (cancelling it would keep a page recording after Turn off).
    if (isRecordingReloadInProgress()) return undefined;

    const e = event || window.event;
    e.preventDefault();

    if (e) {
      e.returnValue = "";
    }

    return "";
  };

  const setTutorRole = (isUserAcq) => {
    const role = window.localStorage.getItem('role');
    const isTutorRole = role === 'ROLE_TUTOR';
    setIsTutorRole(isTutorRole);

    if (role) {
      setIsUserLoggedIn(true);
    }

    if (role && !isTutorRole & !isUserAcq) {
      window.addEventListener("beforeunload", preventNav);
      // Re-entry guard is for ACTIVE exams only. Review mode is read-only:
      // a refresh, bookmark, back/forward, or shared link into /review is a
      // POP entry, and punting it to the quiz builder silently destroys the
      // student's review session (UX-sweep slice-2 P1 QREV-1 — the REVIEW
      // deep-link rendered create-quiz with dead counts and no explanation).
      if (history.action === "POP" && !review && !resumedAfterRecordingReload) {
        history.push("/create-quiz");
      }
    }
  }
  const onExamCompLoad = () => {
    let isUserAcq = false;

    // For User Acquisition flow
    if (currentRoute.includes("/question/view")) {
      isUserAcq = true;
      setIsUserAcquisition(isUserAcq);
      setLegacyQuestionNum(1);
      persistAttribution();

      // Extract platform from URL for QLink session tracking
      const urlParams = new URLSearchParams(window.location.search);
      setQlinkPlatform(normalizeQLinkPlatform(urlParams.get('platform')));

      if (qId) {
        // Put this tab's copy of THIS link's share token back before the read,
        // so a reload/Back works even after the shared key was cleared.
        restoreQLinkShareToken(qId);
        dispatch(getDemoQuestionIDs(qId));
      }
    }

    setTutorRole(isUserAcq);
  }

  // Runtime client-config (in-quiz egress C0): pinned bundles cannot receive
  // a CRA build-time flag, so resolve serverGradingEnabled from the server at
  // quiz mount. Fail-open: any error/non-200/malformed payload is a no-op and
  // the flag keeps its built value (OFF today).
  useEffect(() => {
    api.getClientConfig().then(applyClientConfig).catch(() => {});
  }, []);

  // What this quiz keeps across the reload that turns recording off.
  useEffect(() => onBeforeRecordingReload(() => {
    if (oversight) return;
    stashExamReloadState({
      answers: { examHistoryData, strikedHistoryData, testingTime: { ...testingTime } },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), []);

  useEffect(() => {
    onExamCompLoad();

    return () => {
      if (!isUserAcquisition) {
        dispatch(resetQuesFeedback());
        handleClose();
      }

      if (guideWindow) {
        guideWindow.close();
      }
      const role = window.localStorage.getItem('role');
      const isTutorRole = role === 'ROLE_TUTOR';
      if (!isTutorRole) {
        window.removeEventListener("beforeunload", preventNav);

        // Clear this exam before the destination starts its own request.
        // A delayed reset erases the result route's request identity/data.
        dispatch(resetQuiz());
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (qlinkQsIds && qlinkQsIds?.demoQsIds) {
      const demoQsIds = getQuestionIds(qlinkQsIds?.demoQsIds);

      // This endpoint already returns the public same-case stem/options.
      // Keep them available even when a stored login cannot fetch guidance;
      // otherwise a first-entry failure has no question on which to show its
      // sign-in/retry action. Never treat this public seed as an auth reveal.
      if (isAcquisitionRoute) {
        const publicQuestions = normalizeQuestions(qlinkQsIds.demoQsIds).map(stripGuidanceFields);
        setQuestionsData(previous => previous.length ? previous : publicQuestions);
      }

      globalThis.localStorage.setItem("userAcqQuesId", qId);
      if (globalThis.localStorage.getItem("token")) {
        fetchAcquisitionQuestionMetadata(demoQsIds);
        return;
      }

      dispatch(getDemoQuestionMetadata({ question_list: demoQsIds }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qlinkQsIds]);

  useEffect(() => {
    if (!examId) {
      return;
    }

    if (oversight) {
      // Same reducers, guarded proxy data source (contract v1.1 A-2).
      dispatch(getOversightQuiz({ studentUserId, quizId: examId }));
      dispatch(getOversightQuestionHistory({ studentUserId, quizId: examId }));
      dispatch(getOversightQuizHistory({ studentUserId, quizId: examId }));
      return;
    }

    dispatch(getQuiz(examId));

    if (review || tutor) {
      dispatch(getQuestionHistory(examId));
      dispatch(getQuizHistory(examId));
    }
  }, [dispatch, examId, review, tutor, oversight, studentUserId]);

  useEffect(() => {
    if (examDetails && examDetails.questions) {
      setQuestionsQuizId(examDetails.id);
      setQuestionsData(examDetails.questions);
      return;
    }
    setQuestionsQuizId(null);
    setQuestionsData([]);
  }, [examDetails]);

  // Review mode is only legitimate for COMPLETED quizzes. Without this gate,
  // a mid-exam student could open /exam/<id>/1/review in a second tab and
  // read the answer key the review UI renders (adversarial gate on #517 —
  // the POP exemption alone lowered that bar to a URL edit). Enforced on the
  // loaded quiz details regardless of how the route was entered.
  useEffect(() => {
    if (review && examDetails && examDetails.quizStatus && examDetails.quizStatus !== "COMPLETE") {
      // Oversight lands back on the student panel — /create-quiz would start
      // the OVERSEER building a quiz, the wrong surface entirely.
      history.replace(oversight ? oversightExitPath : "/create-quiz");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [review, examDetails, history]);

  useEffect(() => {
    if (demoQuestionMetadata) {
      if (demoQuestionMetadata?.questionMetadata && !demoQuestionMetadata?.questionMetadata?.errMsg) {
        const ques = normalizeQuestions(demoQuestionMetadata?.questionMetadata);

        if (globalThis.localStorage.getItem("token")) {
          setQuestionsData(prevQuestions => prevQuestions.length ? prevQuestions : [...ques]);
          return;
        }

        // Demo (public) content carries no receipt and is never filtered by
        // the render-time provenance gate.
        adoptedQlinkReceiptRef.current = null;
        setQuestionsData([...ques]);
        setQuestionMetadataArr([...ques]);
      } else if (demoQuestionMetadata?.errMsg) {
        setErrMsg(demoQuestionMetadata?.errMsg);
      }
    }
  }, [demoQuestionMetadata]);

  function fetchAcquisitionQuestionMetadata(questionIds = getQuestionIds(questionsData), options = {}) {
    const { force = false, allowDemoFallback = true } = options;
    const qsIds = [...questionIds].filter(Boolean);

    if (!qsIds.length) {
      return;
    }

    if (globalThis.localStorage.getItem("token")) {
      const shareToken = globalThis.localStorage.getItem("userAcquisitiontoken");
      if (!shareToken || !qId) {
        // No same-case entitlement to assert: actionable unavailable/reopen
        // guidance, never an unbounded fallback to generic bank metadata
        // (QLINK-EXPLANATION-CONTRACT-SEPT16 §5 UI).
        authenticatedMetadataRequestRef.current = "";
        activeQlinkReceiptRef.current = null;
        setQlinkGuidanceUnavailable(true);
        return;
      }
      setQlinkGuidanceUnavailable(false);
      const authSnapshot = currentQlinkAuthEpoch();
      // Auth rotation (genuine re-login, account switch, refreshed token):
      // clear everything the previous auth revealed BEFORE refetching, so
      // stale-by-auth guidance never bridges the gap while the new request
      // is in flight.
      if (activeQlinkReceiptRef.current && activeQlinkReceiptRef.current.auth !== authSnapshot) {
        setQuestionMetadataArr([]);
        setQuestionsData((prevQuestions) => prevQuestions.map(stripGuidanceFields));
        dispatch(resetQuestionMetadata());
      }
      // The key embeds CASE + AUTH: a new login on the same case is a NEW
      // request (the refresh must fire even for the same user), and a late
      // result for another case/auth is recognizable where it arrives.
      const requestKey = `${authSnapshot}::${qId}::${qsIds.join("|")}`;
      if (force || authenticatedMetadataRequestRef.current !== requestKey) {
        authenticatedMetadataRequestRef.current = requestKey;
        qlinkRequestSeqRef.current += 1;
        const receipt = {
          requestId: `${qlinkRequestSaltRef.current}-${qlinkRequestSeqRef.current}`,
          linkId: qId,
          auth: authSnapshot,
        };
        activeQlinkReceiptRef.current = receipt;
        // Explicit same-case context: the CURRENT qId plus the LOCAL share
        // token — never a stale stored link id. apiService routes this to
        // the dedicated authenticated student-questions endpoint and echoes
        // the receipt (only) back on the result.
        dispatch(getQuestionMetadata({
          question_list: qsIds,
          qlinkStudent: { linkId: qId, token: shareToken, receipt },
        }));
      }
      return;
    }

    if (allowDemoFallback && globalThis.localStorage.getItem("userAcquisitiontoken")) {
      dispatch(getDemoQuestionMetadata({ question_list: qsIds }));
    }
  }

  
  const fetchQuestionMetadata = () => {
    if (!questionsData?.length) return;
    if (isUserAcquisition) {
      fetchAcquisitionQuestionMetadata(undefined, { force: true });
      return;
    }
    questionsData.forEach((element) => {
      questionParam.question_list.push(element.questionId);
    });
    if (questionParam.question_list.length) {
      dispatch(oversight
        ? getOversightQuestionMetadata({
            studentUserId, quizId: examId, question_list: questionParam.question_list })
        : getQuestionMetadata({ ...questionParam, ...(examId ? { quizId: examId } : {}) }));

      if (questionHistory?.length) {
        setQuizHistoryData(questionHistory);
      }
    }
  }

  useEffect(() => {
    if (questionsData?.length && !isUserAcquisition) {
      questionsData.forEach((element) => {
        questionParam.question_list.push(element.questionId);
      });

      if (questionParam.question_list.length) {
        if (!questionMetadata) {
          dispatch(oversight
            ? getOversightQuestionMetadata({
                studentUserId, quizId: examId, question_list: questionParam.question_list })
            : getQuestionMetadata({ ...questionParam, ...(examId ? { quizId: examId } : {}) }));
        }

        if (questionHistory?.length) {
          setQuizHistoryData(questionHistory);
        }
      }
    } else if (questionsData?.length && isUserAcquisition) {
      const token = globalThis.localStorage.getItem("token");
      const userAcquisitiontoken = globalThis.localStorage.getItem("userAcquisitiontoken");
      const shouldFetchQLinkMetadata = token ||
        (userAcquisitiontoken && !hasUsableDemoQuestionMetadata(demoQuestionMetadata));

      if (shouldFetchQLinkMetadata) {
        fetchAcquisitionQuestionMetadata();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, questionHistory, questionsData, isUserAcquisition, userDetailsFromTokenRes]);

  useEffect(() => {
    if (currentQuestion) {
      const number = parseInt(currentQuestion);
      setLegacyQuestionNum(number);
    }

    if (questionsData?.length && currentQuestionNum > 0) {
      const questionData = questionsData[currentQuestionNum - 1];

      if (questionData?.imageList?.length && (!imageDataRes?.image || !imageDataRes?.image[questionData.imageList[0]])) {
        dispatch(getImage(questionData.imageList[0]));
      }

      if (!tutor && !review) {
        startTimer();

        return () => {
          clearInterval(interval);
        };
      } else if (review && questionHistory) {
        startTimer();

        return () => {
          examHistoryData = {};
          clearInterval(interval);
          updateReviewApi();
        };
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentQuestion, currentQuestionNum, questionsData, questionHistory]);

  /*
   * ACTIVATION MEASUREMENT (time_to_first_question), in TWO effects of its own.
   *
   * It used to be four lines inside the effect above, and a reviewer proved that
   * arrangement could never work. Two independent reasons, and fixing either
   * alone changes nothing:
   *
   *   THE DATA WAS NEVER THERE. state.userDetailsFromToken is populated ONLY by
   *   login.jsx and PhoneAuthSection — nothing on App mount, nothing here — and
   *   routes.jsx sends a token-holding student from / straight to /create-quiz.
   *   So a returning student never passes through /login, the slice is empty for
   *   the life of the page, and the metric reported only on sessions that had
   *   just logged in. That is the same-session bias this feature moved
   *   server-side to escape, reintroduced by the delivery path.
   *
   *   AND THE EFFECT COULD NOT SEE IT ARRIVE. The effect above is keyed on
   *   [currentQuestion, questionsData, questionHistory] under an
   *   eslint-disable, so even once /user/me landed, nothing re-ran.
   *
   * Separate effects rather than widening that one's deps: it starts and clears
   * the exam timer, and adding userDetailsFromTokenRes there would restart the
   * student's timer every time /user/me resolved.
   */
  const activationAccountId = userDetailsFromTokenRes?.id;

  /*
   * AN ALLOW-LIST, NOT A BLACKLIST, and the difference was measured. The first
   * version excluded review/tutor/guide/oversight by name — and this same
   * component also serves /question/view/:qId (single-question preview) and
   * /qlink/preview/:qlinkId (shared-link preview), neither of which carries any
   * of those params. Both emitted: a reviewer got a full event off each.
   *
   * Requiring examId closes the class instead of the two instances. A student
   * activating is on a real quiz; a blacklist has to be extended every time a
   * route reuses this page, and nobody remembers.
   */
  const isActivationSurface =
    Boolean(examId) && !review && !tutor && !guide && !oversight;

  useEffect(() => {
    // Fetch only what is missing, and only where the event can fire — an extra
    // /user/me on a tutor's oversight screen buys nothing.
    if (!isActivationSurface) return;
    if (activationAccountId) return;
    if (!window.localStorage.getItem("token")) return;
    dispatch(userDetailsFromToken());
  }, [dispatch, isActivationSurface, activationAccountId]);

  useEffect(() => {
    /*
     * REVIEW AND OVERSIGHT ARE EXCLUDED, and this file already holds that
     * convention: updateReviewApi() returns early under oversight because
     * "review-time tracking belongs to the OWNER's review sessions, never an
     * overseer's" (contract I5). An activation event fired while a TUTOR reads a
     * student's answers measures the tutor's account against a student's screen,
     * and the payload carries no role to filter on afterwards.
     */
    if (!isActivationSurface) return;

    /*
     * A question is really ON SCREEN — not "a quiz was created", not "the exam
     * route mounted", both of which happen without the student seeing a stem.
     *
     * Guarded on questionData, not on questionsData.length: a deep link to
     * /exam/<id>/25 in a 10-question quiz passes the length check while the
     * container renders "Loading...", and the event would fire AND LATCH on a
     * question that does not exist — so the student's real first question is
     * never reported.
     */
    const questionData = questionsData[currentQuestionNum - 1];
    if (!questionData) return;

    trackFirstQuestionReached({
      createdAt: userDetailsFromTokenRes?.createdAt,
      accountId: activationAccountId,
    });
  }, [
    isActivationSurface,
    questionsData, currentQuestionNum,
    userDetailsFromTokenRes, activationAccountId,
  ]);

  useEffect(() => {
    if (questionMetadata && questionMetadata.length) {
      if (isAcquisitionRoute) {
        // Provenance adoption gate (§6.5 + round-2 correction): only a
        // result carrying the receipt of the LATEST issued request, under
        // the auth that is live RIGHT NOW, may render. This refuses metadata
        // left over from a previous quiz or case (no receipt), a late
        // response for the same question under another link identity, and a
        // late response from a previous login — including a private link now
        // opened by a different account.
        if (!isCurrentQlinkReceipt(questionMetadata.qlinkReceipt)) {
          return;
        }
        const metadataQuestions = normalizeQuestions(questionMetadata);
        // Defense-in-depth behind the receipt: the response may only carry
        // questions this request actually asked for.
        const requestKey = authenticatedMetadataRequestRef.current;
        const requestedIds = new Set(
          (requestKey.split("::")[2] || "").split("|").filter(Boolean)
        );
        const isStaleResult =
          !requestedIds.size ||
          metadataQuestions.some((item) => !requestedIds.has(item.questionId));
        if (isStaleResult) {
          return;
        }
        adoptedQlinkReceiptRef.current = questionMetadata.qlinkReceipt;
        setQuestionMetadataArr(metadataQuestions);
        setQuestionsData(prevQuestions => mergeQuestionsWithMetadata(prevQuestions, metadataQuestions));
        return;
      }

      setQuestionMetadataArr(questionMetadata);
    }
  }, [questionMetadata, isAcquisitionRoute]);

  // Case navigation inside the acquisition route: the previous case's request
  // identity and any of its guidance still in the store must not leak into
  // the new case.
  const lastAcquisitionCaseRef = useRef("");
  useEffect(() => {
    if (!isAcquisitionRoute || !qId) {
      return;
    }
    if (lastAcquisitionCaseRef.current && lastAcquisitionCaseRef.current !== qId) {
      authenticatedMetadataRequestRef.current = "";
      activeQlinkReceiptRef.current = null;
      adoptedQlinkReceiptRef.current = null;
      setQlinkGuidanceUnavailable(false);
      // The previous case's questions/guidance are wrong WHOLESALE for the
      // new case — an honest loading state beats another case's content.
      setQuestionMetadataArr([]);
      setQuestionsData([]);
      dispatch(resetQuestionMetadata());
    }
    lastAcquisitionCaseRef.current = qId;
  }, [dispatch, isAcquisitionRoute, qId]);

  // A stored login the server rejects before its exp (secret rotation,
  // tokenVersion revocation) passes every client-side check, so this page
  // mounts signed in; the first authenticated call 401s and the stale-session
  // guard confirms and clears it WITHOUT navigating (QLink is a public entry
  // route). Switch to the signed-out path a stranger gets: the public answer
  // check, the sign-in wall, the explanation after sign-in. Otherwise the
  // receipt gate drops the 401 (no live token) and the drawer dead-ends on
  // "We couldn't load the explanation".
  useEffect(() => {
    if (!isAcquisitionRoute) {
      return undefined;
    }
    return subscribeToSessionCleared(() => setSessionClearCount((count) => count + 1));
  }, [isAcquisitionRoute]);

  useEffect(() => {
    if (!sessionClearCount || !isAcquisitionRoute || globalThis.localStorage.getItem("token")) {
      return; // nothing cleared yet, not a QLink page, or a newer sign-in won
    }
    setIsUserLoggedIn(false);
    setIsTutorRole(false);
    setQlinkGuidanceUnavailable(false);
    authenticatedMetadataRequestRef.current = "";
    activeQlinkReceiptRef.current = null;
    setQuestionMetadataArr([]);
    dispatch(resetQuestionMetadata());
    // Nothing is refetched. The link's public payload (stem, options, images,
    // categories) already seeded questionsData, which is all the signed-out
    // path renders; a recovery request could only fail (a public-metadata
    // error replaces the whole page) and race a re-sign-in. Guidance a login
    // revoked mid-visit had revealed is hidden by the render-time provenance
    // gate: no live token matches its receipt. If the clear lands before the
    // link's questions, their effect sees no token and takes the stranger's
    // path itself.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionClearCount]);

  useEffect(() => {
    if (reviewQuestionData && reviewQuestionData.isLoading !== undefined) {
      setIsLoading(reviewQuestionData.isLoading);
    }
  }, [reviewQuestionData]);

  useEffect(() => {
    if (submitQuizRes && submitQuizRes.quizStatus === "COMPLETE") {
      // Null-safe: same analytics-before-navigation hazard as the
      // quiz-history Review button (this parse ran before history.push).
      let userinfos = {};
      try {
        userinfos = JSON.parse(localStorage.getItem('userdetails')) || {};
      } catch (e) {
        // tracking context is optional; submission flow is not
      }
      const userrole = window.localStorage.getItem("role");
      const isDiagnosticQuiz = submitQuizRes?.quizType === "ABSITE_DIAGNOSTIC"
        || examDetails?.quizType === "ABSITE_DIAGNOSTIC";
      examHistoryData = {};
      strikedHistoryData = {};
      dispatch(resetSubmitQuiz());
      dispatch(resetQuiz());
      setQuestionsData([]);
      // quizFinished: the results page reads today's allowance only on arrival from
      // a submit (this success path), never from leaving a review (endBlock below).
      if (isDiagnosticQuiz) history.push(`/absite-diagnostic/${examId}/report`);
      else history.push(`/result/${examId}`, { quizFinished: true });

      if (review) {
        mixpanel.track('Review quiz completed', {
          examId
        });
      } else if (tutor) {
        mixpanel.track('Tutoring quiz completed', {
          examId
        });
      } else {
        mixpanel.track('Quiz completed', {
          $name: userinfos.name,
          "Value": 10.00, // Assign a monetary value to the event
          email: userinfos.email,
          role: userrole
        });
        // Mobile activation: completing a real quiz is the activation "aha"
        // moment. Fires once per user, native-only (no-op on web / off native).
        trackMobileFirstQuizCompleted({ examId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, examId, history, submitQuizRes]);

  useEffect(() => {
    const questionData = questionsData[currentQuestionNum - 1];
    if (imageDataRes && imageDataRes?.loading) {
      setIsImageLoading(true);
      return;
    }

    if (imageDataRes?.image && questionData?.imageList?.length && imageDataRes?.image[questionData.imageList[0]]) {
      setQuestionImage({ id: questionData.imageList[0], data: imageDataRes.image[questionData.imageList[0]] });
    } else {
      setQuestionImage('');
    }
    setIsImageLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageDataRes, currentQuestion, currentQuestionNum, questionsData]);

  useEffect(() => {
    if (isTutorRole && questionsData) {
      const questionData = questionsData[currentQuestionNum - 1];
      if (questionMetadata && questionMetadata.length) {
        const currentQues = questionMetadata.filter(
          (item) => item.id === questionData?.questionId
        );
        setQuesMetadata(currentQues[0]);
        const channel = new BroadcastChannel('app-data');
        channel.postMessage(currentQues[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionMetadata, currentQuestionNum]);

  useEffect(() => {
    if (setQuesTutorFeedbackRes?.quesTutorFeedback && setQuesTutorFeedbackRes?.loading === false) {
      setOpen(true);
    }

    if (setQuesTutorFeedbackRes?.errorMsg && setQuesTutorFeedbackRes?.loading === false) {
      setErrMsg(setQuesTutorFeedbackRes?.errorMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setQuesTutorFeedbackRes]);

  useEffect(() => {
    if (userDetailsFromTokenRes?.status === 200 || userDetailsFromTokenRes?.id) {
      const userAcquisitionQuesId = window.localStorage.getItem("userAcqQuesId");
      if (userAcquisitionQuesId) {
        if (userDetailsFromTokenRes?.id) {
          window.localStorage.setItem("userId", userDetailsFromTokenRes?.id);
          window.localStorage.setItem("role", userDetailsFromTokenRes?.primaryRole);
        }

        setTimeout(() => {
          onExamCompLoad();
        }, 500);

      }
    } else if (userDetailsFromTokenRes && (userDetailsFromTokenRes?.status === 401 || !userDetailsFromTokenRes?.id)) {
      alert('User not registered');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetailsFromTokenRes]);

  const handleQuestionSelection = (questionIndex) => {
    const userAcqQuesId = window.localStorage.getItem("userAcqQuesId");
    setLegacyQuestionNum(questionIndex);

    if (tutor) {
      history.push(`/exam/${examId}/${questionIndex}/tutor/1`);
    } else if (!review && !userAcqQuesId) {
      history.push(`/exam/${examId}/${questionIndex}`);
    } else if (oversight) {
      dispatch(getOversightQuestionHistory({ studentUserId, quizId: examId }));
      dispatch(getOversightQuizHistory({ studentUserId, quizId: examId }));
      history.push(oversightReviewPath(questionIndex));
    } else {
      addUserActivityOnReview();
      if (!userAcqQuesId) {
        dispatch(getQuestionHistory(examId));
        dispatch(getQuizHistory(examId));
        history.push(questionReviewPath(examId, questionIndex, questionsData[questionIndex - 1]?.questionId));
      }
    }
  };

  const handleTextZoom = (className) => {
    setZoomClass(className);
  };

  const handleProceedToNextQuestion = () => {
    const userAcqQuesId = window.localStorage.getItem("userAcqQuesId");
    const num = currentQuestionNum + 1;
    setLegacyQuestionNum(num);

    if (tutor) {
      history.push(`/exam/${examId}/${num}/tutor/1`);
    } else if (!review && !userAcqQuesId) {
      history.push(`/exam/${examId}/${num}`);
    } else if (oversight) {
      dispatch(getOversightQuestionHistory({ studentUserId, quizId: examId }));
      dispatch(getOversightQuizHistory({ studentUserId, quizId: examId }));
      history.push(oversightReviewPath(num));
    } else {
      addUserActivityOnReview();
      if (!userAcqQuesId) {
        dispatch(getQuestionHistory(examId));
        dispatch(getQuizHistory(examId));
        history.push(questionReviewPath(examId, num, questionsData[num - 1]?.questionId));
      }
    }
  };

  const onExamHistoryChange = (data, type, extraData) => {
    examHistoryData = { ...data };

    if (type === "marked") {
      setQuestionsData([...extraData]);
    }
  };

  const onStrikeDataChange = (data) => {
    strikedHistoryData = { ...data };
  };

  const getMarkedVal = (quesId) => {
    if (questionMetadata && !questionMetadata?.errMsg) {
      const ques = questionMetadata?.filter(item => item.id === quesId);

      return questionMetadata && ques?.length ? ques[0].marked : false;
    }
    return false;

  };

  const onEndBlock = (timeLeft, type) => {
    setShowEndBlock(false);
    setQuestionImage('');
    dispatch(resetQuestionMetadata());

    if (!review) {
      const timePerQues = 90;
      const timeSpent = timePerQues * questionsData.length - (timeLeft || 0);

      const questionHistories = questionsData.map((item) => {
        return {
          questionId: item.questionId,
          answerGiven: examHistoryData[item.questionId]?.answerGiven,
          marked: examHistoryData[item.questionId]?.marked !== undefined ? examHistoryData[item.questionId]?.marked : getMarkedVal(item.questionId),
          timeSpent: testingTime[item.questionId],
          answersAttempted: [],
          questionNo: item.questionNo
        };
      });

      const param = {
        questionHistories,
        quizHistory: {
          quizId: examId,
          userId: examDetails.userId,
          questionAttemptCount: questionsData.length,
          quizSubmitDate: moment().format('YYYY-MM-DDTHH:mm:ss.sss') + 'Z',
          quizDuration: examDetails?.timerOn ? timeSpent : 0
        },
      };

      dispatch(submitQuiz(param));
      return;
    }
    clearInterval(interval);

    if (type === "submitted" || type === "reviewEnd") {
      endFeedBackBlock();
      updateReviewApi();
      if (type === "reviewEnd") {
        history.push(oversight ? oversightExitPath : '/create-quiz');
      } else if (oversight) {
        history.push(`/mentorships/students/${studentUserId}/result/${examId}`);
      } else {
        const isDiagnosticQuiz = examDetails?.quizType === "ABSITE_DIAGNOSTIC";
        history.push(isDiagnosticQuiz ? `/absite-diagnostic/${examId}/report` : `/result/${examId}`);
      }
      setQuestionsData([]);
    } else if (type === "remain-in-block") {
      startTimer();
    }
  };

  const addUserActivityOnReview = () => {
    if (oversight) {
      return; // viewer-keyed activity counter — suppressed in oversight (I5)
    }
    const savedUserId = window.localStorage.getItem("userId");
    if (savedUserId) {
      dispatch(setUserActivity({
        userId: savedUserId,
        videoAccessCount: 1
      }));
    }

  };

  const onShowEndBlock = (show) => {
    setShowEndBlock(show);
  };

  const onFeedbackOpen = (show) => {
    if (oversight) {
      return; // question feedback writes as the viewer — suppressed (I5)
    }
    setFeedbackOpen(show);
  };

  const goToHomePage = () => {
    if (review) {
      dispatch(resetQuestionMetadata());
      clearInterval(interval);
      endFeedBackBlock();
      updateReviewApi();
      history.push(oversight ? oversightExitPath : `/create-quiz`);
    } else if (isUserAcquisition) {
      // Same exam seed as the drawer's Start practicing (qlink-exam-seed.js).
      const practiceState = buildQlinkPracticeState(resolveQlinkExamLabel(
        renderQuestionsData[currentQuestionNum - 1]?.categories?.examType
      ));
      if (practiceState) {
        history.push(`/create-quiz`, practiceState);
      } else {
        history.push(`/create-quiz`);
      }
      dispatch(resetDemoQuestionMetadata());
      dispatch(resetDemoQuestionIDs());
      window.localStorage.removeItem("userAcqQuesId");
      window.localStorage.removeItem("userAcquisitiontoken");
    }
  };

  const onGuidePopOut = () => {
    if (oversight) return;
    if (!guideWindow) {
      let path = window.location.pathname;

      if (review) {
        path = path.replace('review', 'tutor/1');
      }

      guideWindow = window.open(path + '/guide/1', '_blank', 'width=800,height=700,left=700,popup');

      guideWindow.addEventListener('load', () => {
        guideWindow.addEventListener('beforeunload', (e) => {
          e.preventDefault();
          guideWindow = null;
          e.returnValue = true;
        });
      });
    } else {
      alert('Guide already open');
    }
  }

  // Add a new useEffect to handle browser navigation and ensure data is reloaded
  useEffect(() => {
    // Listen for popstate event (when user uses browser back/forward buttons)
    const handlePopState = () => {
      if (examId && oversight) {
        // Gate finding B2/F2: browser back/forward must refetch through the
        // guarded proxy — the owner-scoped read 403s for tutor overseers and
        // clobbers the loaded oversight data.
        dispatch(getOversightQuestionHistory({ studentUserId, quizId: examId }));
        return;
      }
      if (examId && (review || tutor)) {
        // Re-fetch question history when navigating with browser controls
        dispatch(getQuestionHistory(examId));
      }
    };

    window.addEventListener('popstate', handlePopState);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [dispatch, examId, review, tutor, oversight, studentUserId]);

  // Keep quizHistoryData in sync whenever questionHistory is updated
  useEffect(() => {
    if (questionHistory && questionHistory.length) {
      setQuizHistoryData(questionHistory);
    }
  }, [questionHistory]);

  // QLink same-case guidance error, status preserved: apiService's failure
  // errMsg is a { qlinkGuidance, status, receipt } object the untouched
  // saga/reducer stored verbatim in questionMetadataErrMsg; the
  // missing-share-token state synthesizes the same unavailable shape
  // locally. The receipt gate keeps a STALE error (an abandoned earlier
  // request failing slowly) from overriding the latest request's outcome.
  // The drawer keys its sign-in/unavailable/retry split off the status.
  const storedQuestionMetadataErrMsg = questionMetadataState?.questionMetadataErrMsg;
  const qlinkGuidanceError = selectQlinkGuidanceError(
    isAcquisitionRoute, qlinkGuidanceUnavailable,
    storedQuestionMetadataErrMsg, isCurrentQlinkReceipt
  );

  // Render-time provenance gate (round-2): effects clear stale-by-auth
  // content only AFTER a first re-render has painted, so the frame between
  // an auth change and the clearing effect must not show the previous auth's
  // guidance either. Content adopted from the authenticated route renders
  // ONLY while its receipt is still current; demo (public) content carries
  // no receipt and is unaffected, as is every non-acquisition surface.
  const qlinkAuthContentStale = isAcquisitionRoute
    && !!adoptedQlinkReceiptRef.current
    && !isCurrentQlinkReceipt(adoptedQlinkReceiptRef.current);
  const renderQuestionsData = qlinkAuthContentStale
    ? questionsData.map(stripGuidanceFields)
    : questionsData;
  const renderQuestionMetadataArr = qlinkAuthContentStale ? [] : questionMetadataArr;

  const reviewStatus = getSelectedReviewStatus({ requestedReviewQuestionId, currentQuestionNum,
    examDetailsLoading, examDetails, questionsQuizId, examId, oversight, studentUserId, history });
  if (reviewStatus) return reviewStatus;

  const emptyQuestionStatus = getEmptyQuestionStatus({ examDetailsLoading, questionsData,
    demoQuestionMetadata, qlinkQsIds, questionMetadata, classes });
  if (emptyQuestionStatus) return emptyQuestionStatus;

  const acquisitionLayout = getAcquisitionLayout(isAcquisitionRoute, renderQuestionsData.length,
    !isUserLoggedIn && !hasStoredSession());

  return (
    <>
      {qlinkQsIds?.errMsg ? (
        <QLinkLinkError status={qlinkQsIds?.status} expired={qlinkQsIds?.expired === true} />
      ) : (
        <div className={`${classes[zoomClass]} ${!review ? 'quiz-page' : 'review-page'}${acquisitionLayout.className}`}>
          <Snackbar open={open} onClose={handleClose} autoHideDuration={4000}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Box className="success-alert">
              Thank you for your feedback...
            </Box>
          </Snackbar>
          <Snackbar open={errMsg} onClose={handleClose} autoHideDuration={4000}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Box className="sub-alert">
              {errMsg}
            </Box>
          </Snackbar>
          <Backdrop className={classes.backdrop} open={isLoading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Backdrop className={classes.backdrop} open={isImageLoading}>
            <CircularProgress color="inherit" />
          </Backdrop>

          {!demoQuestionMetadata?.errMsg &&
            <>
              {!guide &&
                <Box component="div" className={classes.examContainer}>
                  {!acquisitionLayout.hideQuestionRail && <ExamQuestionNumberList
                    questionData={renderQuestionsData}
                    onSelectQuestion={handleQuestionSelection}
                    examHistoryData={examHistoryData}
                    quizHistoryData={quizHistoryData}
                    questionMetaData={renderQuestionMetadataArr}
                    isReview={!!review}
                    currentQuestion={currentQuestionNum}
                  />}
                  {/* exam-content-column: the phone layout that keeps the
                      question area above the End Block footer
                      (exam-question-container.scss). The overall-performance
                      page also uses exam-container-wrapper, so it gets its own
                      class. */}
                  <Box component="div" className={`${classes.examContentContainer} exam-container-wrapper exam-content-column`}>
                    <ExamHeader
                      preferLocalMarks={resumedAfterRecordingReload}
                      readOnly={oversight}
                      currentQuestion={currentQuestionNum}
                      questionData={renderQuestionsData}
                      questionMetaData={renderQuestionMetadataArr}
                      onSelectQuestion={handleQuestionSelection}
                      onTextZoom={handleTextZoom}
                      examHistoryData={examHistoryData}
                      onExamHistoryChange={onExamHistoryChange}
                      quizHistoryData={quizHistoryData}
                      isReview={!!review}
                      isTutor={!!tutor}
                      feedbackOpen={feedbackOpen}
                      onFeedbackClose={onFeedbackOpen}
                      goToHomePage={goToHomePage}
                      isUserAcquisition={isUserAcquisition}
                    />
                    {isTutorRole && tutor && !oversight &&
                      <IconButton
                        onClick={() => onGuidePopOut()}
                        title="Pop Out"
                        className="pop-out-icon-outer"
                      >
                        <Launch />
                      </IconButton>
                    }
                    <ExamQuestionContainer
                      readOnly={oversight}
                      currentQuestionNum={currentQuestionNum}
                      dataLength={renderQuestionsData.length}
                      questionData={renderQuestionsData[currentQuestionNum - 1]}
                      onProceedToNextQuestion={handleProceedToNextQuestion}
                      isReview={!!review}
                      isTutor={!!tutor}
                      examHistoryData={examHistoryData}
                      onExamHistoryChange={onExamHistoryChange}
                      strikedHistoryData={strikedHistoryData}
                      onStrikeDataChange={onStrikeDataChange}
                      questionMetadata={renderQuestionMetadataArr}
                      quizHistoryData={quizHistoryData}
                      imageData={imageData}
                      onShowEndBlock={onShowEndBlock}
                      onFeedbackOpen={onFeedbackOpen}
                      isUserAcquisition={isUserAcquisition}
                      userDetailsFromTokenRes={userDetailsFromTokenRes}
                      handleFetchQuestionMetadata={fetchQuestionMetadata}
                      questionMetadataError={qlinkGuidanceError || resolveQuestionMetadataError({
                        isUserAcquisition,
                        questionMetadataState,
                        demoQuestionMetadata,
                        qlinkQuestionMetadata: renderQuestionMetadataArr
                      })}
                      questionMetadataLoading={questionMetadataLoading || demoQuestionMetadata?.loading === true}
                      questionMetadataLoaded={questionMetadataLoaded || Array.isArray(demoQuestionMetadata?.questionMetadata) || !!demoQuestionMetadata?.questionMetadata?.errMsg || !!demoQuestionMetadata?.errMsg}
                      qlinkId={qId}
                      qlinkPlatform={qlinkPlatform}
                      quizId={examId}
                    />
                    <ExamFooter
                      resumedTimeLeftTotal={resumeAfterRecordingReloadRef.current?.timeLeftTotal}
                      isReview={!!review}
                      isTutor={!!tutor}
                      quizDetails={examDetails}
                      questionsDataLength={questionsData.length}
                      onEndBlock={onEndBlock}
                      showEndBlock={showEndBlock}
                      currentQuestionNum={currentQuestionNum}
                      isUserAcquisition={isUserAcquisition}
                      goToHomePage={goToHomePage}
                      userDetailsFromTokenRes={userDetailsFromTokenRes}
                    />
                  </Box>
                </Box>
              }
              {guide &&
                <Box className="quide-review-cont">
                  <ExamReviewDrawer
                    readOnly={oversight}
                    questionData={quesMetadata}
                    openDrawer={true}
                    isTutor={tutor}
                    isGuide={guide}
                    isReview={review}
                    isUserLoggedIn={isUserLoggedIn}
                    onFeedbackOpen={(evt, data) => onFeedbackOpen(true, data)}
                    handleFetchQuestionMetadata={fetchQuestionMetadata}
                  ></ExamReviewDrawer>
                </Box>
              }
            </>
          }
          {demoQuestionMetadata?.errMsg &&
            <Box className="invalid-link">Sorry. Please try again...</Box>
          }

        </div>
      )}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  examContainer: {
    display: "flex",
    flexDirection: "row",
    // The visible height on phones. 100vh is the height with the browser's
    // toolbars hidden, so while they show (mobile Safari, Chrome) the bottom
    // of the question area ran below the visible screen while the fixed End
    // Block footer sits at its visible bottom. Same as 100vh on desktop and
    // in the iPhone app; browsers without dvh keep 100vh.
    height: "100dvh",
    fallbacks: { height: "100vh" },
    // iOS safe area: keep the exam shell below the status bar / Dynamic Island
    // (global viewport-fit=cover would otherwise let it extend under the notch).
    // env() is 0 on desktop web; border-box preserves the 100vh height.
    boxSizing: "border-box",
    paddingTop: "env(safe-area-inset-top)",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  examContentContainer: {
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  smallFont: {
    zoom: "100%",
  },
  mediumFont: {
    zoom: "110%",
  },
  largeFont: {
    zoom: "120%",
  },
  noQuestionsAvailableMessage: {
    fontSize: '20px',
    margin: '200px 50px',
    textAlign: 'center',
    height: '50px',
    color: '#d32f2f'
  }
}));
